"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownMenu = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var button_type_1 = require("../../elements/button/button-type");
var icon_1 = require("../../elements/icon/icon");
var icon_type_1 = require("../../elements/icon/icon-type");
var dropdown_menu_style_1 = require("./dropdown-menu-style");
function DropdownMenu(props) {
    var _a = props.icon, icon = _a === void 0 ? (0, jsx_runtime_1.jsx)(icon_1.Icon, { iconName: icon_type_1.IconName.CHEVRON_DOWN }) : _a, toggleProps = props.toggleProps, restProps = __rest(props, ["icon", "toggleProps"]);
    return ((0, jsx_runtime_1.jsx)(dropdown_menu_style_1.StyledDropDownMenu, __assign({}, restProps, { icon: icon, toggleProps: __assign({ iconPosition: button_type_1.ButtonIconPosition.END }, toggleProps) })));
}
exports.DropdownMenu = DropdownMenu;
